export default function ActiveDocument() {
  return {
    template: require('./active-document.html'),
    scope: {
      document: '=',
      permissions: '<',
      isNavantaUser: '=',
    },
    controller: 'ActivePmDocumentController',
    controllerAs: 'activeDocumentVM',
    bindToController: true,
    replace: true,
  };
}
